import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface OverallPerformance {
  BottomMeasures: any[];
  TopMeasures: any[];
  OverallPercentile: number;
  OverallRating: number;
}

export const get = (today: Date, memberInfo: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_MEASURES_REQUEST });

  const searchModel = {
    "AgeInMonths": today,
    "NewPatientFlag": 'N',
    "CompanyId": memberInfo.RmiCompanyId,
    "StartDate": memberInfo.RmiStartDate,
    "ICD_Version": '10',
    "EndDate": memberInfo.RmiEndDate,
    "Gender": memberInfo.RmiSex
  };

  return api.eligibility.measures.get(searchModel)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEASURES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEASURES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

//eligibility claim generator to get measures
export const getForMember = (memberInfo: any, measureYear: number, memberMeasureStatus: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_MEMBER_MEASURES_REQUEST });

    const searchModel = {
      "CompanyId": memberInfo.RmiCompanyId,
      "MembMpiNo": memberInfo.RmiMembMpiNo,
      "MembKeyId" : memberInfo.RmiMembKeyId,
      "NewPatient": memberInfo.RmiNewPatient,
      "DateOfService": '01/01/' + measureYear,
      "MeasureYear": measureYear,
      "UserId": sessionStorage.getItem('user_id')
    }

  return api.eligibility.measures.getForMember(searchModel)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEMBER_MEASURES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEMBER_MEASURES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getMembers = (measureCode: string, provKey: string, companyId: string, lob: string, pageIndex: number, pageSize: number, measureYear: number, vendorId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_MEASURE_MEMBERS_REQUEST });

  if (lob === 'ALL') lob = '';

  return api.eligibility.measures.getMembers(measureCode, provKey, companyId, lob, pageIndex, pageSize, measureYear, vendorId)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEASURE_MEMBERS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEASURE_MEMBERS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getPrintFile = (materials: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_MEMBER_MEASURE_PRINT_FILE_REQUEST });

  return api.eligibility.measures.getPrintFile(materials)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEMBER_MEASURE_PRINT_FILE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEMBER_MEASURE_PRINT_FILE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getHedisMeasures = (measureCode: string, measureName: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.REFRESH_MEMBER_MEASURES_REQUEST });

  const model = {
    "MeasureCode": measureCode,
    "MeasureName": measureName,
    "CptCode": null,
    "IcdCode": null,
    "Screening": null
  };

  return api.eligibility.measures.getHedisMeasures(model)
    .then((res: any) => {

      dispatch({
        type: types.REFRESH_MEMBER_MEASURES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.REFRESH_MEMBER_MEASURES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getProviderOverallPerformance = (model: Object) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.REFRESH_MEMBER_MEASURES_REQUEST });

  return api.eligibility.measures.getProviderOverallPerformance(model)
    .then((res: any) => {

      dispatch({
        type: types.REFRESH_MEMBER_MEASURES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.REFRESH_MEMBER_MEASURES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
